export enum OrgStatus {
    New = 0,
    Active = 1,
    Closed = 2,
    Inactive = 3,
    Deleted = 4
}
